import React from 'react';
import { Grid } from '@mui/material';
import FormTextField from '../../../../../Components/Form/FormTextField';
import DefaultExtensionData from './DefaultExtensionData';
import keysToLowerCase from '../../../../../Helpers/keysToLowerCase';

const Dossier = function Dossier({
  errors,
  watch,
  defaultData = {},
  setValue,
  activityTypes,
}) {
  const extensionData = keysToLowerCase(
    JSON.parse(defaultData?.extensionData || '{}')
  );

  return (
    <>
      <DefaultExtensionData
        errors={errors}
        watch={watch}
        setValue={setValue}
        defaultData={defaultData}
        activityTypes={activityTypes}
      />
      <Grid size={6}>
        <FormTextField
          name="importId"
          error={errors?.importId}
          defaultValue={extensionData?.importId || ''}
        />
      </Grid>
    </>
  );
};

export default Dossier;
